<template>
	<div class="content">
    <base-header class="pb-6">
	<div class="row align-items-center py-4">
        <div class="col-lg-6 col-7">
          <h6 class="h2 text-white d-inline-block mb-0">
            {{ $t("profile.info") }}
          </h6>
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
				<route-breadcrumb />
			</nav>
        </div>

       
      </div>
	</base-header>

	<div class="container-fluid mt--6">
  <card>
    <div slot="header" class="row align-items-center">
      <div class="col-8">
        <h3 class="mb-0">เปลี่ยนรหัสผ่าน</h3>
      </div>
    </div>

	<validation-observer ref="formValidator">
    <form @submit.prevent="updatePassword">
      <div class="pl-lg-4">
		<div class="row">
          <div class="col-lg-6">
            <base-input
              type="password"
			  rules="required"
              :label="$t('password')"
              :name="$t('password')"
              v-model="params.password"
            >
            </base-input>
          </div>
		</div>
		<div class="row">
			<div class="col-lg-6">
            <base-input
              type="password"
			  rules="required"
              :label="$t('password_confirm')"
              :name="$t('password_confirm')"
              v-model="params.password_confirm"
            >
            </base-input>
          </div>
        </div>

		<div class="row">
		  <div class="col-lg-6">
			<base-button
			  type="primary"
			  size="md"
			  @click="updatePassword"
			  >Save</base-button>
		  </div>
		</div>
	  </div>


     

    </form>
	</validation-observer>
  </card>
  </div>
  </div>
</template>
<script>

import { mapGetters, mapActions, mapMutations } from 'vuex';
import BaseButton from '../../components/BaseButton.vue';
import swal from "sweetalert2";
export default {
  components: { BaseButton },
  data() {
    return {
      params: {
		password : "",
		password_confirm : "",
		}
    };
  },
  computed:{
	...mapGetters({
		Profile: 'Auth/getUser',
	})

  },
  mounted(){

  },
  methods: {
	...mapActions({
		changeProfile: 'Auth/changeProfile',
		changePassword:'Auth/changePassword'
	}),

    updatePassword() {
		if (this.$refs.formValidator.validate()) {

			if (this.params.password != this.params.password_confirm){
				swal.fire({
					title: 'Error',
					text: 'Password not match',
					icon: 'error',
					confirmButtonText: 'OK'
				});
				return;
			}
			this.changePassword(this.params).then((resp) => {
				swal.fire({
					title: 'Success',
					text: 'Password has been updated',
					icon: 'success',
					confirmButtonText: 'OK'
				});
				this.$router.push({ name: 'BOOrders' });
			}).catch((err)=>{
				swal.fire({
					title: 'Error',
					text: err,
					icon: 'error',
					confirmButtonText: 'OK'
				});
			});
		}
    }
  }
};
</script>
<style></style>
